import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import HWLog from "../../HWLibrary/HWLog";
import dayjs from "dayjs";
import Select from "react-select";

class MessageA13 extends Component {

    render() {
        let optionsArray = this.parseListValues().map(item => { return { value: item.value, label: item.name } });
        return (
            <div className="s360-message-cotainer-custom-a13-received">
                <div className="s360-message-box-custom-a13-received" style={this.messageBoxStyle()}>
                    <Select options={optionsArray} captureMenuScroll={false} isSearchable={false}  onChange={this.onListItemSelect} styles={this.selectOptionsStyle} components={{ IndicatorSeparator: () => null }}/>
                </div>
                {this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
            </div>
        );
    }

    onListItemSelect = (item) => {
        this.props.actions.sendMessage(item.value);
    }

    parseListValues = () => {
        try {
            return JSON.parse(this.props.entry.text).data || []
        } catch (error) {
            HWLog.warn("Invalid List Data for Custom Type A13:");
        }
        return []
    }

    messageBoxStyle = () => {
        return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
    }

    messageTimeStyle = () => {
        return { fontFamily: s360ConfigService.config.designDetails.messageFont, fontSize: s360ConfigService.config.designDetails.messageTimeFontSize, color: s360ConfigService.config.designDetails.messageFontColor }
    }

    selectOptionsStyle = {
        control: (provided, state) => ({
            ...provided,
            border: "none",
            boxShadow: 'none',
            borderRadius: '0px',
            color: s360ConfigService.config.designDetails.headerColor,
            width: '100% !important',
            '&:hover': {
                border: "none"
            }
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: s360ConfigService.config.designDetails.headerColor,
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = s360ConfigService.config.designDetails.headerColor;
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? color
                            : null,
                ':active': {
                    ...styles[':active'],
                    backgroundColor: null,
                },
                borderBottom: '1px solid #ccc',
            };
        },
    };


}

export default MessageA13;